<template>
  <InteractionStep
                   :disabled-next="!value"
                   :pending-next="pendingSave"
                   @next="onSave">
    <template v-slot:content>
      <div class="step-text">
        <div class="step-text__text text">
          <p>{{ $tInteraction('After the job invitation for the candidate is ready, be sure to confirm it by clicking the appropriate button below') }}</p>
        </div>
        <div class="step-text__options step-options">
          <div class="step-options__inner">
            <label class="step-options__item">
              <input type="radio"
                     name="type-option"
                     :value="VALUE_DATE"
                     v-model="value"
                     hidden>
              <span class="step-options__item-mark">
                <BaseSvg name="ico-check"/>
              </span>
              <span class="step-options__item-inner">
                <span>{{$tInteraction('Schedule a visit to the Visa Application Center')}}</span>
              </span>
            </label>
            <label class="step-options__item">
              <input type="radio"
                     name="type-option"
                     :value="VALUE_DOCUMENT"
                     v-model="value"
                     hidden>
              <span class="step-options__item-mark">
                <BaseSvg name="ico-check"/>
              </span>
              <span class="step-options__item-inner">
                <span>{{$tInteraction('Send documents to the visa center')}}</span>
              </span>
            </label>
          </div>
        </div>
      </div>
      <BaseAlert :value="error" class="step-information__error  _error"/>
      <BaseAlert :value="message" class="step-information__error  _warning"/>
    </template>
  </InteractionStep>
</template>

<script>
  import {http} from '../../../axios'
  import InteractionStep from '../InteractionStep'
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  const VALUE_DATE = 'is_visit_date_set'
  const VALUE_DOCUMENT = 'sent_documents'

  export default {
    name: 'InteractionStepPassport2',
    mixins: [interactionStepMixin],
    data() {
      return {
        VALUE_DATE,
        VALUE_DOCUMENT,
        pendingSave: false,
        error: null,
        value: null,
        message: null
      }
    },
    components: {
      InteractionStep
    },
    methods: {
      onSave() {
        this.error = null
        this.message = null
        this.pendingSave = true

        const step = this.$store.state.interaction.step

        const sendData = {
          [this.value]: 1
        }

        http.post(`/api/new-interaction/${this.$route.params.id}/${step}`, sendData).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      },
    }
  }
</script>

<style>

</style>
